import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@totalsoft/rocket-ui';
import { ArrowBack } from '@mui/icons-material';

const HeaderLinks = ({ onClickClose, onSave, disabledSave }) => {
  const { t } = useTranslation();
  return (
    <>
      <IconButton fontSize='medium' color='transparent' tooltip={t('DocumentTypes.BackToList')} onClick={onClickClose}>
        <ArrowBack />
      </IconButton>
      <IconButton type='save' fontSize='medium' color='transparent' tooltip={t('Tooltips.Save')} onClick={onSave} disabled={disabledSave} />
    </>
  );
};

HeaderLinks.propTypes = {
  onClickClose: PropTypes.func.isRequired,
  disabledSave: PropTypes.bool.isRequired,
  onSave: PropTypes.func
};

export default HeaderLinks;
